import { useEffect } from 'react'
import Boutton from '@piconetworks/pkg-boutton'
import { format } from '@piconetworks/pkg-currency'

import { useCallToAction } from 'features/FeatureManager'

const CTA = ({
    children = null,
    id = null,
    app = null,
    acceptedCtaSessionId = null,
    pricingId = null,
    onAccepted = (args = {}) => {},
    onPresented = (args = {}) => {},
    onDeclined = (args = {}) => {},
} = {}) => {
    const pricing = app?.getPricingById(pricingId)
    const appName = app?.name

    const priceText = format({ amount: pricing?.amount, currency: pricing?.currency, symbol: true })
    const priceInterval = pricing?.interval

    const {
        isVisible,
        show,
        accept,
        decline,
    } = useCallToAction({
        acceptedCtaSessionId,
        id,
        appLabels: [app?.label],
        userId: app?.userId,
        publisherId: app?.publisherId,
        onAccepted,
        onPresented,
        onDeclined,
    })

    useEffect(() => {
        if (isVisible) {
            return
        }

        show()
    }, [isVisible])

    return (
        <Boutton disabled={!isVisible} onClick={accept} variant="primary">{children}</Boutton>
    )
}

export default CTA
